import { DefaultAxios } from "../../config/axios";
import { SOCKET_EVENT_TYPE, SOCKET_MESSAGE_PROVIDER, STATUS } from "../../constants/avatar";
import { GetAPIDomain } from "../../lib/common";
import { SendSocket } from "../../lib/socket";
import { store } from "../../store";
import { AuthConstant, AvatarConstant } from "../reducers";
import { AuthAction } from "./AuthAction";

const setAuth = (item, dispatch) => {
	const { _id, ownerGroupId, region } = item;
	const user = {
		_id,
		groupId: ownerGroupId,
		service: "da_viewer",
		region,
	};
	dispatch({ type: AuthConstant.SET_AUTH, item: user });
};

const CheckAvatarId = (id, region) => async (dispatch) => {
	try {
		dispatch({ type: AvatarConstant.SET_LOADING, bool: true });
		const apiDomain = GetAPIDomain("project", region);
		let url = apiDomain + '/v1.0.1/projectinfobycaseidnoauth/' + id + '?sk=qr:c';
		let ret = await DefaultAxios.get(url);
		if (ret?.data?.status === "success" && ret?.data?.data?._id) {
			let item = ret.data.data;
			url = apiDomain + '/v1.0.1/projectinfobycaseidnoauth/' + id + '?sk=qr:u';
			ret = await DefaultAxios.get(url);
			if (ret?.data?.status === "success") {
				item = { ...item, ...ret.data.data };
				if (!item?._id && !item.status) {
					item.status = STATUS.WRONG;
				} else if (item?._id && !item.status) {
					item.status = STATUS.NEW;
				}
			}
			dispatch({ type: AvatarConstant.SET_ID, id: id });
			dispatch({ type: AvatarConstant.SET_AVATAR, item: item });
			setAuth(item, dispatch);
			// 의도적 fire-and-forget: 헤더 로딩 표시는 groupLoading 상태(AuthReducer)로 처리
			dispatch(AuthAction.GetGroupInfo(item.ownerGroupId));
			dispatch({ type: AvatarConstant.SET_LOADING, bool: false });
			return item;
		} else {
			// dispatch({ type: AuthConstant.CLEAR_AUTH });
		}
		dispatch({ type: AvatarConstant.SET_LOADING, bool: false });
		return null;
	} catch (error) {
		console.log("ERROR[CheckAvatarId]", error.toString());
	}
	dispatch({ type: AvatarConstant.SET_LOADING, bool: false });
	return null;
};

const AgreeAvatar = () => async (dispatch) => {
	try {
		const password = store.getState().AvatarReducer.password;
		const tempPassword = store.getState().AvatarReducer.tempPassword;
		const avatarItem = store.getState().AvatarReducer.item;
		if (!tempPassword || !avatarItem?._id || !avatarItem?.creator) {
			return false;
		}
		const apiDomain = GetAPIDomain("project", avatarItem?.region);
		let url = `${apiDomain}/da-viewer/avatars/${avatarItem._id}/password`;
		const formDataPW = {
			password: password || tempPassword,
			data: {
				password: tempPassword,
			},
		};
		const retPW = await DefaultAxios.post(url, formDataPW);
		if (retPW.data.status !== "success") {
			return false;
		}
		url = `${apiDomain}/da-viewer/avatars/${avatarItem._id}`;
		const formDataUpdate = {
			password: tempPassword,
			data: {
				termsAt: new Date().getTime(),
				status: STATUS.TERMS,
			},
		};
		const retUpdate = await DefaultAxios.post(url, formDataUpdate);
		if (retUpdate.data.status !== "success") {
			return false;
		}
		const payload = {
			data: {
				users: [avatarItem.creator],
				message: {
					provider: SOCKET_MESSAGE_PROVIDER,
					type: SOCKET_EVENT_TYPE.AVATAR_TERMS,
					_id: avatarItem._id,
					name: avatarItem?.name,
					patientId: avatarItem?.patientId,
					rtGuid: avatarItem?.rtGuid,
				},
			},
		};
		const isSuccess = SendSocket(payload);
		return isSuccess;
	} catch (error) {
		console.log("ERROR[AgreeAvatar]", error.toString());
	}
};

const CheckAvatar = async () => {
	try {
		const avatarItem = store.getState().AvatarReducer.item;
		const { _id: id, region, status } = avatarItem;
		if (status === STATUS.DELETE) {
			return;
		}
		const apiDomain = GetAPIDomain("project", region);
		let url = apiDomain + '/v1.0.1/projectinfobycaseidnoauth/' + id + '?sk=qr:u';
		let ret = await DefaultAxios.get(url);
		return ret?.data?.data;
	} catch (error) {
		console.log("ERROR[CheckAvatar]", error?.response?.data || error?.toString());
	}
};

const RefreshAvatar = () => async (dispatch) => {
	try {
		const avatarItem = store.getState().AvatarReducer.item;
		const { _id: id, region, status } = avatarItem;
		if (status === STATUS.DELETE) {
			return;
		}
		dispatch({ type: AvatarConstant.SET_LOADING, bool: true });
		const apiDomain = GetAPIDomain("project", region);
		let url = apiDomain + '/v1.0.1/projectinfobycaseidnoauth/' + id + '?sk=qr:c';
		let ret = await DefaultAxios.get(url);
		if (ret?.data?.status === "success" && ret?.data?.data?._id) {
			let item = ret.data.data;
			url = apiDomain + '/v1.0.1/projectinfobycaseidnoauth/' + id + '?sk=qr:u';
			ret = await DefaultAxios.get(url);
			if (ret?.data?.status === "success") {
				item = { ...item, ...ret.data.data };
			}
			dispatch({ type: AvatarConstant.SET_ID, id: id });
			dispatch({ type: AvatarConstant.SET_AVATAR, item: item });
			dispatch({ type: AvatarConstant.SET_LOADING, bool: false });
			return item;
		} else {
			dispatch({ type: AuthConstant.CLEAR_AUTH });
		}
		dispatch({ type: AvatarConstant.SET_LOADING, bool: false });
		return null;
	} catch (error) {
		console.log("ERROR[RefreshAvatar]", error.toString());
	}
};

const ComparePasswordToServer = (password) => async (dispatch) => {
	if (!password) {
		return;
	}
	try {
		const avatarItem = store.getState().AvatarReducer.item;
		const { _id, region } = avatarItem;
		const apiDomain = GetAPIDomain("project", region);
		let url = apiDomain + '/da-viewer/auth';
		const formData = {
			data: { _id, password },
		};
		const ret = await DefaultAxios.post(url, formData);
		return ret.data;
	} catch (error) {
		console.log("ERROR[ComparePasswordToServer]", error.toString());
	}
	return false;
};

const UpdateAvatarToUserConfirm = () => async (dispatch) => {
	try {
		const password = store.getState().AvatarReducer.password;
		const avatarItem = store.getState().AvatarReducer.item;
		if (!avatarItem?._id || !avatarItem?.creator || avatarItem?.status === STATUS.CONFIRMED) {
			return false;
		}
		const apiDomain = GetAPIDomain("project", avatarItem?.region);
		let url = `${apiDomain}/da-viewer/avatars/${avatarItem._id}`;
		const formDataPW = {
			password: password,
			data: {
				status: STATUS.CONFIRMED,
				confirmedAt: new Date().getTime(),
			},
		};
		const ret = await DefaultAxios.post(url, formDataPW);
		if (ret.data.status === "success") {
			// dispatch({ type: AvatarConstant.SET_AVATAR_STATUE, status: STATUS.CONFIRMED });
			const payload = {
				data: {
					users: [avatarItem.creator],
					message: {
						provider: SOCKET_MESSAGE_PROVIDER,
						type: SOCKET_EVENT_TYPE.CONFIRMED,
						_id: avatarItem._id,
						name: avatarItem?.name,
						patientId: avatarItem?.patientId,
						rtGuid: avatarItem?.rtGuid,
					},
				},
			};
			const isSuccess = SendSocket(payload);
			return isSuccess;
		}
	} catch (error) {
		console.log("ERROR[UpdateAvatarToUserConfirm]", error.toString());
	}
	return false;
};

const UnlinkAvatar = ({ password }) => async (dispatch) => {
	try {
		const avatarItem = store.getState().AvatarReducer.item;
		if (!avatarItem?._id || !avatarItem?.creator) {
			return false;
		}
		const apiDomain = GetAPIDomain("project", avatarItem?.region);
		let url = `${apiDomain}/da-viewer/avatars/${avatarItem._id}/unlink`;
		const formDataPW = {
			data: {
				_id: avatarItem._id,
				password: password,
			}
		};
		dispatch({ type: AvatarConstant.SET_LOADING, bool: true })
		const ret = await DefaultAxios.post(url, formDataPW);
		if (ret.data.status === "success") {
			const payload = {
				data: {
					users: [avatarItem.creator],
					message: {
						provider: SOCKET_MESSAGE_PROVIDER,
						type: SOCKET_EVENT_TYPE.DELETE,
						_id: avatarItem._id,
						name: avatarItem?.name,
						patientId: avatarItem?.patientId,
					},
				},
			};
			SendSocket(payload);
			dispatch({
				type: AvatarConstant.SET_AVATAR, item: {
					...avatarItem,
					status: STATUS.DELETE,
				}
			});
			dispatch({
				type: AuthConstant.SET_EXISTED_DATA,
				item: {
					_id: avatarItem._id,
					status: STATUS.DELETE,
				}
			});
		}
		dispatch({ type: AvatarConstant.SET_LOADING, bool: false })
		return ret.data;
	} catch (error) {
		console.log("ERROR[UnlinkAvatar]", error.toString());
	}
	dispatch({ type: AvatarConstant.SET_LOADING, bool: false })
	return false;
};


export const AvatarAction = {
	CheckAvatarId,
	AgreeAvatar,
	RefreshAvatar,
	ComparePasswordToServer,
	UpdateAvatarToUserConfirm,
	UnlinkAvatar,
	CheckAvatar,
};
